import type { IconProps } from '.';

/**
 * Youtube Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const YouTubeIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="23"
    viewBox="0 0 20 10"
    fill="none"
    className={className}
  >
    <path
      d="M19.1934 2.39453C19.6152 3.87109 19.6152 7.03516 19.6152 7.03516C19.6152 7.03516 19.6152 10.1641 19.1934 11.6758C18.9824 12.5195 18.3145 13.1523 17.5059 13.3633C15.9941 13.75 10.0176 13.75 10.0176 13.75C10.0176 13.75 4.00586 13.75 2.49414 13.3633C1.68555 13.1523 1.01758 12.5195 0.806641 11.6758C0.384766 10.1641 0.384766 7.03516 0.384766 7.03516C0.384766 7.03516 0.384766 3.87109 0.806641 2.39453C1.01758 1.55078 1.68555 0.882812 2.49414 0.671875C4.00586 0.25 10.0176 0.25 10.0176 0.25C10.0176 0.25 15.9941 0.25 17.5059 0.671875C18.3145 0.882812 18.9824 1.55078 19.1934 2.39453ZM8.04883 9.88281L13.041 7.03516L8.04883 4.1875V9.88281Z"
      fill="white"
    />
  </svg>
);

export default YouTubeIcon;
